// Per il dev
// var stripe = Stripe('pk_test_PO6MvEvM6bq3JxU32t6PMe88');
// var product = Stripe('prod_IObMAx5Wdh3l1E');

// Per la prod
var stripe = Stripe('pk_live_b0B2wvrh1tBMqtet8Ny2BPKB');
var product = Stripe('price_1Hpeo3EESMr4ycI2bhR48UBo');

// If a fetch error occurs, log it to the console
var handleFetchResult = function(result) {
  if (!result.ok) {
    return result.json().then(function(json) {
      if (json.error && json.error.message) {
        throw new Error(result.url + ' ' + result.status + ' ' + json.error.message);
      }
    });
  }
  return result.json();
};

// Create a Checkout Session with the selected plan ID
var createCheckoutSession = function(priceId) {
  var AUTH_TOKEN = document.querySelector('meta[name=csrf-token]').content;
  return fetch("/billing", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      authenticity_token: AUTH_TOKEN
    })
  }).then(handleFetchResult);
};

// Handle any errors returned from Checkout
var handleResult = function(result) {
  if (result.error) {
    var displayError = document.getElementById("error-message");
    displayError.textContent = result.error.message;
  }
};

function setupStripeButton(checkoutEl){
  checkoutEl.addEventListener("click", function(evt) {
    createCheckoutSession(product).then(function(data) {
      // Call Stripe.js method to redirect to the new Checkout page
      stripe
        .redirectToCheckout({
          sessionId: data.sessionId
        })
        .then(handleResult);
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {
  var checkoutEls = document.getElementsByClassName("js-checkout")// document.getElementById("checkout")
  for (let i = 0; i < checkoutEls.length; i++) {
    let el = checkoutEls[i]
    setupStripeButton(el)
  }
})
